import { InteractionOffer } from "~/app/core/model/interaction/interaction-offer";
import { InteractionAd } from "~/app/core/model/interaction/interaction-ad";
import { DateStr } from "~/app/core/model/date-str";
import { InteractionOther } from "~/app/core/model/interaction/interaction-other";

export class InteractionAggregate {
    deadline: DateStr;
    wifiDeadline: DateStr;

    offers: {[key: string]: InteractionOffer };
    ads: {[key: string]: InteractionAd };
    other: InteractionOther;
}
